/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('AuditTrail_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBooking = $resource( baseUrl +'rest/auditTrails/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET'}

        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('AuditTrail',["AuditTrail_Resource","AuditTrailData", function (AuditTrail_Resource,AuditTrailData)
    {
        var  AuditTrail = function (resource)
        {
            this.id = null;
            this.timeCreated = null;
            this.number = null;
            this.code = null;
            this.label = null;
            this.description = null;
            this.userId = null;
            this.signature = null;
            this.pSignature = null;

            this.loadObject(resource);
            AuditTrailData.add(this);
        }
        AuditTrail.prototype.loadObject = function(object)
        {
            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id = object.id;
                this.timeCreated = object.timeCreated;
                this.number = object.number;
                this.code = object.code;
                this.label = object.label;
                this.description = object.description;
                this.userId = object.userId;
                this.signature = object.signature;
                this.pSignature = object.pSignature;

            }
        }
        AuditTrail.prototype.getObjectResource = function()
        {
            var rsAuditTrail = new AuditTrail_Resource();
            rsAuditTrail.id = this.id;
            rsAuditTrail.code = this.code;
            rsAuditTrail.description = this.description;
            return rsAuditTrail;
        }

        AuditTrail.prototype.getId = function()
        {
            return this.id;
        }

        AuditTrail.prototype.setId = function(id)
        {
            this.id = id;
        }

        return AuditTrail;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('AuditTrailSrv',["$log","AuditTrail_Resource","AuditTrail","AuditTrailData","ServerSrv",
        function ($log,AuditTrail_Resource,AuditTrail,AuditTrailData,ServerSrv)
        {
        var  auditTrailSrv = {};

        auditTrailSrv.query = function(successFunction,errorFunction)
        {
            AuditTrail_Resource.query(
                {}, //params
                function (data) {   //success
                    AuditTrailData.clear() ;
                    for (var i=0;i< data.length;i++)
                        new AuditTrail(data[i]);//Auto Add to AuditTrailData
                    if (successFunction!== undefined)
                        successFunction(AuditTrailData.indexAuditTrails);

                },
                function (data) {   //failure
                    $log.error("AuditTrail_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        auditTrailSrv.createAndSave = function(code,successFunction,errorFunction)
        {
            var auditTrail = new AuditTrail();
            auditTrail.code = code;
            ServerSrv.startSavingProcess(auditTrailSrv.saveSync, auditTrail, successFunction, errorFunction);
        };
        auditTrailSrv.save = function(auditTrail,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(auditTrailSrv.saveSync, auditTrail, successFunction, errorFunction);
        };
        auditTrailSrv.saveSync = function(auditTrail,successFunction,errorFunction)
        {
            //$timeout (function () {

            var AuditTrailRes = auditTrail.getObjectResource();
            AuditTrailRes.$save({}, //no params
                function (data) {
                    try{
                        auditTrail.setId(data.id);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };


        auditTrailSrv.get =  function(id,successFunction,errorFunction)
        {
            AuditTrail_Resource.get(
                {id:id}, //params
                function (auditTrailResource) {
                    if (successFunction!=undefined)
                        successFunction(new AuditTrail(auditTrailResource));
                },
                function (data) {
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });
        };


        return auditTrailSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('AuditTrailData',["$filter", function ($filter)
    {
        var  auditTrailDataSrv =
        {
            indexAuditTrails : []

        };
        auditTrailDataSrv.getById =  function(auditTrailId)
        {
            for (var i=0;i<this.indexAuditTrails.length;i++)
                if (this.indexAuditTrails[i].getId()==auditTrailId)
                    return this.indexAuditTrails[i];
            return null;
        }
        auditTrailDataSrv.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexAuditTrails.length)
                return this.indexAuditTrails[index];
            return null;
        }
        auditTrailDataSrv.getIndexOf =  function(auditTrail)
        {
            if (auditTrail)
                return this.indexAuditTrails.indexOf(auditTrail);
            return -1;
        }

        auditTrailDataSrv.add =  function(auditTrail)
        {
            var index =  this.indexAuditTrails.indexOf(auditTrail);
            if (index==-1)
            {
                index = this.indexAuditTrails.length
                this.indexAuditTrails.push(auditTrail);
            }
            return index;
        }        
        auditTrailDataSrv.clear =  function()
        {
            this.indexAuditTrails = [];
        }
        return   auditTrailDataSrv;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/AuditTrail.js